import { useRouter } from 'next/router';
import type { CSSProperties } from 'react';
import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';

import { fullDealLandingPageRoute } from '@src/shared/constants/pageRoutes';
import inlineCalculationsStyles from 'entities/FullDeal/ui/InlineCalculations/InlineCalculations.module.scss';

import { FULL_DEAL_ENTRY_POINT_TEXTS, FULL_DEAL_WEB_TO_WEB_LINKS, FULL_DEAL_WEB_TO_WEB_SOURCE } from '../../config';
import { buildHasOfferLinkForFullDeal, openMobileApp } from '../../lib';
import { ToFullDealAdvertisingButton } from '../ToFullDealAdvertisingButton/ToFullDealAdvertisingButton';

import styles from './FullDealOfferActions.module.scss';

export interface FullDealOfferActionsProps {
  amount: number;
  term: number;
  hasIssuedMicrocreditDeals: boolean;
  toFullDealButtonText: string;
  toFullDealButtonColor?: ButtonProps['color'];

  seoHeading?: string;
  className?: string;
  style?: CSSProperties;

  onMyLoansClick?: (event: React.SyntheticEvent, seoHeading: string) => void;
}

export const FullDealOfferActions = ({
  className,
  amount,
  term,
  hasIssuedMicrocreditDeals,
  toFullDealButtonText,
  toFullDealButtonColor = 'dark',
  seoHeading,
  style,
  onMyLoansClick = openMobileApp,
}: FullDealOfferActionsProps) => {
  const isMobile = useIsMobile();
  const { asPath } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');
  const isLandingPage = pathWithoutQuery.includes(fullDealLandingPageRoute);

  const linkWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_LINKS.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_LINKS.FROM_REFERAL_VITRINA;

  const sourceWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_REFERAL_VITRINA;

  const primaryButton = (
    <ToFullDealAdvertisingButton
      className={className}
      variant="primary"
      link={buildHasOfferLinkForFullDeal({
        link: linkWebToWeb,
        amount,
        term,
        ...(isLandingPage && {
          showAuth: true,
          referrer: asPath,
        }),
      })}
      color={toFullDealButtonColor}
      size={52}
      source={sourceWebToWeb}
      linkTarget="_self"
      block
      style={style}
    >
      {toFullDealButtonText}
    </ToFullDealAdvertisingButton>
  );

  if (isMobile) {
    return (
      <div className={inlineCalculationsStyles.mobileActionsCard}>
        {primaryButton}
        {hasIssuedMicrocreditDeals && (
          <Button size={52} block color="dark" className={styles.text} onClick={(e) => onMyLoansClick(e, seoHeading)}>
            {FULL_DEAL_ENTRY_POINT_TEXTS.mobileAppButtonText}
          </Button>
        )}
      </div>
    );
  }

  return (
    <Space direction="row" size={8}>
      {primaryButton}

      {hasIssuedMicrocreditDeals && (
        <Button size={52} block color="dark" className={styles.text} onClick={(e) => onMyLoansClick(e, seoHeading)}>
          {FULL_DEAL_ENTRY_POINT_TEXTS.mobileAppButtonText}
        </Button>
      )}
    </Space>
  );
};
